'use strict';

import BaseService from './base.service';

class WorkersService extends BaseService {
    /* @ngInject */
    constructor(Worker, SegaUser) {
        super(Worker, SegaUser);
        Object.assign(this, {
            Worker
        });
    }
}

export default WorkersService;
